const rankingItems = [
  {
    rank: 1,
    title: '霸道总裁的契约新娘',
    genre: '韩漫·恋爱',
    hot: '128.6万',
    status: '连载至128话',
    update: '今日更新',
  },
  {
    rank: 2,
    title: '修仙大佬在都市',
    genre: '国漫·修仙',
    hot: '115.3万',
    status: '连载至205话',
    update: '今日更新',
  },
  {
    rank: 3,
    title: '甜蜜的陷阱',
    genre: '韩漫·悬疑',
    hot: '98.7万',
    status: '已完结',
    update: '全集可读',
  },
  {
    rank: 4,
    title: '末日生存指南',
    genre: '国漫·末日',
    hot: '87.2万',
    status: '连载至89话',
    update: '昨日更新',
  },
  {
    rank: 5,
    title: '重生之豪门千金',
    genre: '韩漫·豪门',
    hot: '76.5万',
    status: '连载至312话',
    update: '今日更新',
  },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            热度排行
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            热门排行
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            布丁漫画网本周热度最高的漫画作品排行，支持布丁漫画下拉式免费阅读
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          <div className="bg-background-100 border border-background-200/70 rounded-3xl overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={item.title}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
                } hover:bg-background-50 transition-colors cursor-default`}
              >
                <div className={`w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-400 text-background-50'
                    : item.rank === 3
                    ? 'bg-primary-300 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <span className="text-sm font-heading">{item.rank}</span>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-base font-semibold text-foreground-900 truncate">
                      {item.title}
                    </h3>
                    <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium whitespace-nowrap">
                      {item.genre}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 mt-1 text-xs text-foreground-400 flex-wrap">
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {item.hot}人气
                    </span>
                    <span>{item.status}</span>
                  </div>
                </div>

                <div className="flex items-center gap-2 flex-shrink-0">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${
                    item.update.includes('今日')
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {item.update}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}